import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import { Form, FieldTextInput, Modal } from '../../components';

import css from './ProfilePage.module.css';

const EndorsementModal = props => {
    const { 
        isOpen, 
        onClose, 
        onSubmit, 
        sendEndorsementEmailInProgress, 
        sendEndorsementEmailError,
        onManageDisableScrolling
    } = props;
    const intl = useIntl();

    const emailRequired = validators.required(
        intl.formatMessage({
            id: 'ProfilePage.endorsementEmailRequired',
        })
    );
    const emailValid = validators.emailFormatValid(
        intl.formatMessage({
            id: 'ProfilePage.endorsementEmailInvalid',
        })
    );

    const firstNameRequired = validators.required(
        intl.formatMessage({
            id: 'ProfilePage.endorsementFirstNameRequired',
        })
    );

    return (
            <Modal isOpen={isOpen} onClose={onClose} onManageDisableScrolling={onManageDisableScrolling} className={css.endorsementModalWrapper}> 
            <div className={css.endorsementModal}>
                <h2 className={css.modalTitle}>
                    <FormattedMessage id="ProfilePage.endorsementModalTitle" />
                </h2>

                <p className={css.modalSubtitle}>
                    <FormattedMessage id="ProfilePage.endorsementModalHelpText" />
                </p>
                <div className={css.divider}>

                </div>
                {sendEndorsementEmailError && (
                    <p className={css.error}>
                        <FormattedMessage id="ProfilePage.endorsementEmailError" />
                    </p>
                )}

                <FinalForm
                    onSubmit={onSubmit}
                    render={({ handleSubmit, submitting, pristine, invalid }) => (
                        <Form className={css.endorsementForm} onSubmit={handleSubmit}>
                            <FieldTextInput
                                type="text"
                                id="firstName"
                                name="firstName"
                                label={intl.formatMessage({ id: 'ProfilePage.endorsementFirstNameLabel' })}
                                placeholder={intl.formatMessage({ id: 'ProfilePage.endorsementFirstNamePlaceholder' })}
                                validate={firstNameRequired}
                            />
                            <FieldTextInput
                                type="email"
                                id="email"
                                name="email"
                                label={intl.formatMessage({ id: 'ProfilePage.endorsementEmailLabel' })}
                                placeholder={intl.formatMessage({ id: 'ProfilePage.endorsementEmailPlaceholder' })}
                                validate={validators.composeValidators(emailRequired, emailValid)}
                            />
                            <div className={css.formActions}>
                                <button type="button" className={css.cancelButton} onClick={onClose}>
                                    <FormattedMessage id="ProfilePage.endorsementCancel" />
                                </button>
                                <button
                                    type="submit"
                                    className={css.submitButton}
                                    disabled={pristine || invalid || submitting || sendEndorsementEmailInProgress}
                                >
                                    <FormattedMessage 
                                        id={sendEndorsementEmailInProgress ? "ProfilePage.endorsementSending" : "ProfilePage.endorsementRequestSubmit"} 
                                    />
                                </button>
                            </div>
                        </Form>
                    )}
                />
            </div>
        </Modal>
    );
};

export default EndorsementModal; 